module.exports = "## Drawer\n\nThe [Drawer](https://www.google.com/design/spec/patterns/navigation-drawer.html) slides in from the side.\nIt is a common pattern found in Google apps and follows the keylines and metrics for lists.\n\nThere are no examples for uncontrolled mode because an uncontrolled `Drawer` can only be opened with a swipe.\nThe doc site has an uncontrolled `Drawer`. Swipe from the left on a touch device to see it.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Drawer/README.md
 ** module id = 977
 ** module chunks = 0
 **/